import React from 'react';
import PropType from 'prop-types';
import { ImageUploads } from '@sendpayments/react-shared/components/ImageUploads';
import { documentSources } from '@sendpayments/js-utils/dist/const/defaults';
import styles from './ListItem.module.less';
import { useFeature } from '@sendpayments/react-shared/hooks/useFeature';
import { PD_4823_REBRANDING_2025 } from '@sendpayments/shared-constants/features';

const RequestDocument = ({ document, onIsListLoaded, onFilesSubmitted, onValidateFile }) => {
  const { docRequestType, docInstructions, docType } = document;
  const { value: documentLabel } = documentSources.find(({ key }) => key === docType) || {};

  const [
    {
      data: { isEnabled: isRebrandActive },
    },
  ] = useFeature({
    feature: PD_4823_REBRANDING_2025,
    activeValue: undefined,
    functionName: `Captcha`,
    defaultValue: undefined,
  });
  const onChangeHandler = (list) => {
    onIsListLoaded(list.length > 0);
  };

  return (
    <div>
      <div className={styles.header}>{docRequestType}</div>
      <div className={styles.desc}>
        {documentLabel}
        {docInstructions}
      </div>
      <div className={styles.imagesUpload}>
        <ImageUploads
          onChange={onChangeHandler}
          onValidateFile={onValidateFile}
          onFilesSubmitted={onFilesSubmitted}
          isRebrandingActive={isRebrandActive}
        />
      </div>
    </div>
  );
};

RequestDocument.propTypes = {
  document: PropType.object,
  onIsListLoaded: PropType.func.isRequired,
  onFilesSubmitted: PropType.func.isRequired,
  onValidateFile: PropType.func.isRequired,
};

RequestDocument.defaultProps = {
  document: undefined,
};

export default RequestDocument;
